import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: () => ({
    error: null,
    loading: false,
    files: [],
    brands: [],
    appVersion: process.env.VUE_APP_VERSION,
  }),
  mutations: {
    setError (state, payload) {
      state.error = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    addFiles (state, payload) {
      const brand = state.brands.find(brand => brand.name == payload.brandName)
      brand.files.push(...payload.files)
    },
    setBrands (state, payload) {
      state.brands = payload
    },
  },
  actions: {
    get_files ({commit, getters}, brandName) {
      const brand = getters.getBrand(brandName)
      const payload = {
        Prefix: brand.Prefix,
        Marker: brand.files[brand.files.length - 1].key,
        MaxKeys: 6 * 2,
      }
      // commit('setLoading', true)
      return Vue.http.post('salessheet/get_files', payload)
      .then(response => response.data)
      .then(data => {
        commit('addFiles', {
          brandName,
          files: data.data,
        })
        return data.data
      })
      .catch(e => {
        commit('setError', e)
        return []
      })
      // .finally(() => commit('setLoading', false))
    },
    get_brands ({commit}, options = {}) {
      const payload = {
        ...options,
      }
      commit('setLoading', true)
      return Vue.http.post('salessheet/get_brands', payload)
      .then(response => response.data)
      .then(data => {
        commit('setBrands', data.data)
        return data.data
      })
      .catch(e => {
        commit('setError', e)
        commit('setBrands', [])
        return []
      })
      .finally(() => commit('setLoading', false))
    },
  },
  getters: {
    error (state) {
      return state.error
    },
    loading (state) {
      return state.loading
    },
    files (state) {
      return state.files
    },
    brands (state) {
      return state.brands
    },
    getBrand: (state) => (name) => {
      return state.brands.find(brand => brand.name == name)
    },

    appVersion (state) {
      return state.appVersion
    },
  },
})
